import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HeartIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const PROMO_END_DATE = new Date('2026-05-12T00:00:00-04:00'); // 11 de mayo 23:59 ET
export function PromoBanner() {
  const [visible, setVisible] = useState(true);
  const [expired, setExpired] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const checkExpiry = () => {
      if (new Date() >= PROMO_END_DATE) {
        setExpired(true);
      }
    };
    checkExpiry();
    const interval = setInterval(checkExpiry, 60000);
    return () => clearInterval(interval);
  }, []);
  if (expired) return null;
  return <AnimatePresence data-id="element-352" data-mp="15qfo68aeltrb">
      {visible && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="relative z-[60] overflow-hidden bg-brand-gold" data-id="element-353" data-mp="1aq0lyfdu7w2g">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-354" data-mp="1xc53d0t5butx">
            <div className="flex items-center justify-center py-2.5 md:py-3 relative" data-id="element-355" data-mp="1xatzl0zpan2t">
              <div className="flex items-center gap-2 md:gap-3 text-center" data-id="element-356" data-mp="1sdkbboo1shgk">
                <HeartIcon className="w-4 h-4 text-white/80 hidden sm:block" data-id="element-357" data-mp="1ocibp6q7y3e2" />
                <p className="text-white text-xs md:text-sm font-medium tracking-wide" data-id="element-358" data-mp="2l295f3qormit">
                  <span className="font-bold text-sm md:text-base" data-id="element-359" data-mp="2g2wjqmbjwlht">
                    {t('promo.discount')}
                  </span>
                  <span className="mx-1.5 text-white/60 hidden sm:inline" data-id="element-360" data-mp="2bav1mjrpc0jv">
                    —
                  </span>
                  <span className="ml-1 sm:ml-0" data-id="element-361" data-mp="27a2o3ebsr9hs">{t('promo.event')}</span>
                </p>
                <span className="text-white/40 mx-2 hidden md:inline" data-id="element-362" data-mp="33ts4izhlagfk">|</span>
                <a href="https://wa.me/15513328938?text=Hola%2C%20quiero%20aprovechar%20el%2020%25%20de%20descuento%20por%20el%20D%C3%ADa%20de%20la%20Madre" target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex items-center text-xs font-bold text-white uppercase tracking-widest hover:text-white/80 transition-colors underline underline-offset-2" data-id="element-363" data-mp="2z0ftjs5u285a">
                  {t('promo.book')}
                </a>
              </div>

              <button onClick={() => setVisible(false)} className="absolute right-0 top-1/2 -translate-y-1/2 p-1.5 text-white/60 hover:text-white transition-colors" aria-label="Cerrar banner" data-id="element-364" data-mp="savpjhdzds5y">
                <XIcon className="w-3.5 h-3.5" data-id="element-365" data-mp="jah3gft7091e" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}